import { render, staticRenderFns } from "./MessageContent.vue?vue&type=template&id=347c343c&"
import script from "./MessageContent.vue?vue&type=script&lang=js&"
export * from "./MessageContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports